import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLabTubeBottle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.29,8.71A.51.51,0,0,1,11,8.25V1a1,1,0,0,0-1-1H6A1,1,0,0,0,5,1V8.25a.51.51,0,0,1-.29.46,8,8,0,1,0,6.58,0ZM14,16.55a.51.51,0,0,1-.5.45h-11a.51.51,0,0,1-.5-.45c0-.18,0-.37,0-.55a6,6,0,0,1,3.75-5.56A2,2,0,0,0,7,8.58V2.5A.5.5,0,0,1,7.5,2h1a.5.5,0,0,1,.5.5V8.58a2,2,0,0,0,1.25,1.86A6,6,0,0,1,14,16C14,16.18,14,16.37,14,16.55Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22,2H18a2,2,0,0,0-2,2v7a1,1,0,0,0,2,0V4.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v3a.5.5,0,0,1-.5.5H21a1,1,0,0,0,0,2h.5a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H21a1,1,0,0,0,0,2h.5a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5H21a1,1,0,0,0,0,2h.5a.5.5,0,0,1,.5.5v1.39A2.08,2.08,0,0,1,20.34,22a2,2,0,0,1-2.22-1.3,1,1,0,0,0-1-.67,1,1,0,0,0-.94,1.3A4,4,0,0,0,20.4,24,4.12,4.12,0,0,0,24,19.82V4A2,2,0,0,0,22,2Z",
		fill: "currentColor"
	})] })
});
export { SvgLabTubeBottle as ReactComponent };
